import { statePlugin } from '../../plugins/state'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin(statePlugin)
